import React, { useEffect } from 'react';
import { Box, Divider, Flex } from '@tonic-one/react';
import { useTranslation } from 'react-i18next';
import { FormLabel } from 'src/components/Common/FormComponent';

import { useWhyDidYouUpdate } from 'src/utils/hooks';
import {
  useTargetAppsSalesforceSandbox,
  useSalesforceSandboxTargetProfilesTarget,
  useSalesforceSandboxObjectsTarget,
} from '@Policy/hooks';
import { TargetUserGroups } from '@Policy/Components/TargetUserGroups';
import { GeneralPolicyInfo, GeneralStatus } from '@Policy/Filters/General';
import {
  storeSelector,
  templateSelector,
  usePolicyContext,
} from '@Policy/store';
import { PolicyHolderTypeEnum } from '@Policy/utils/types';

export const ObjectsTargetSalesforceSandbox = () => {
  const props = useSalesforceSandboxObjectsTarget();
  useWhyDidYouUpdate('ObjectsTargetSalesforceSandbox', {
    ...props,
  });
  return <TargetUserGroups {...props} />;
};

export const AppsTargetSalesforceSandbox = () => {
  const props = useTargetAppsSalesforceSandbox();
  useWhyDidYouUpdate('AppsTargetSalesforceSandbox', {
    ...props,
  });
  return <TargetUserGroups {...props} />;
};

export const ProfilesTargetAppsSalesforceSandbox = () => {
  const props = useSalesforceSandboxTargetProfilesTarget();
  useWhyDidYouUpdate('ProfilesTargetAppsSalesforceSandbox', {
    ...props,
  });
  return <TargetUserGroups {...props} />;
};

export const TargetSalesforce = () => {
  const { t } = useTranslation();
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  const policySelector = templateSelector(contextStore);
  // get state and action from store
  const holderType = policySelector((s) => s.holderType);
  const policyTarget = policySelector((s) => s.policyTargetSalesforce);
  const setTempVars = contextSelector((s) => s.setTempVars);
  useEffect(() => {
    if (policyTarget && policyTarget !== null) {
      setTempVars({
        targetObjects: policyTarget.targetObjects,
        targetProfiles: policyTarget.targetProfiles,
        targetCommunities: policyTarget.targetCommunities,
      });
    }
  }, []);
  return (
    <>
      <Flex mt="23px" alignItems="flex-start">
        <FormLabel label={t('policy.label.policyTarget')} required />
        {holderType === PolicyHolderTypeEnum.ATP ? (
          <AppsTargetSalesforceSandbox />
        ) : (
          <ObjectsTargetSalesforceSandbox />
        )}
      </Flex>
      <Flex mt="23px" alignItems="flex-start" ml="152px">
        <ProfilesTargetAppsSalesforceSandbox />
      </Flex>
    </>
  );
};

const General = () => {
  return (
    <Box>
      <GeneralStatus
        skipScanJunkEmailFolderShow={false}
        mipEnableFeatureShow={false}
        rmsEnabledShow={false}
      />
      <Divider mt="22px" mb="22px" />
      <GeneralPolicyInfo />
      <TargetSalesforce />
    </Box>
  );
};
export default React.memo(General);
